"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = exports.EnvironmentHolder = void 0;
/**
 * Copyright 2021 Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const mfe_framework_1 = require("../framework/mfe-framework");
class EnvironmentHolder {
    get code() {
        try {
            // @ts-ignore
            const env = window[mfe_framework_1.MfeFramework.ENVIRONMENT_KEY];
            if (!env) {
                return mfe_framework_1.MfeFramework.DEFAULT_ENVIRONMENT_CODE;
            }
            return env === null || env === void 0 ? void 0 : env.code;
        }
        catch (e) {
            return null;
        }
    }
    applyConfiguration(targetConfig, sourceConfig) {
        var _a;
        try {
            const code = (_a = this.code) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            if (!code) {
                return targetConfig;
            }
            let envCode = "";
            for (const property in sourceConfig) {
                if (property.toLowerCase() === code) {
                    envCode = property;
                    break;
                }
            }
            const envSpecific = sourceConfig[envCode];
            if (!envSpecific) {
                return;
            }
            return Object.assign(targetConfig, envSpecific);
        }
        catch (e) {
            return targetConfig;
        }
    }
    static getInstance() {
        if (!EnvironmentHolder.instance) {
            EnvironmentHolder.instance = new EnvironmentHolder();
        }
        return EnvironmentHolder.instance;
    }
}
exports.EnvironmentHolder = EnvironmentHolder;
exports.Environment = EnvironmentHolder.getInstance();
//# sourceMappingURL=environment-holder.js.map